const re = (expression) => {
  return new RegExp(expression)
}
export const validators = {
  emailFormat: (email) => {
    return re(/^.+@.+\..+$/).test(email)
  },
  passwordFormat: (password) => {
    return re(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{6,}$/).test(
      password,
    )
  },
  lowercaseValidator: (password) => {
    return re(/[a-z]/).test(password)
  },
  uppercaseValidator: (password) => {
    return re(/[A-Z]/).test(password)
  },
  digitValidator: (password) => {
    return re(/\d/).test(password)
  },
  characterValidator: (password) => {
    return re(/^[a-zA-Z\d]/).test(password)
  },
  lengthValidator: (password) => {
    return password && password.length >= 6
  },
  equals: (first, second) => {
    return first === second
  },
  hasValue: (text) => {
    if (text === undefined) return false
    let value = text
    if (typeof value !== 'string') {
      value = String(value)
    }

    return value.trim() !== ''
  },
  isEntityValues: (values) => {
    return values?.every(
      (value) => value !== undefined && value?.toString().trim() !== '',
    )
  },
}
